<script setup lang="ts">
import type { ButtonProps } from '~/components/Button.vue'
import { faArrowRightFromBracket } from '@fortawesome/pro-duotone-svg-icons'

const { loggedIn } = useUserSession()

const { theme } = useTheme()
const { emphasis } = useButtonEmphasis()

const route = useRoute()

const context = getNavigationContext()

const props = computed<ButtonProps & { label: string }>(() => loggedIn.value
  ? {
      label: 'Logg\xA0ut',
      href: '/logout',
    }
  : {
      label: 'Logg\xA0inn',
      to: {
        name: 'login',
        query: context === 'default'
          ? {
            redirectTo: route.fullPath,
          } satisfies RedirectToQuery
          : {},
      },
    })
</script>

<template>
  <Button
    v-bind="props"
    :color="theme"
    :emphasis="emphasis"
    size="medium"
    variant="primary"
    :icon="faArrowRightFromBracket"
    icon-position="left"
    class="reading-dark:bg-surface-elevated"
  >
    {{ props.label }}
  </Button>
</template>
